export default __webpack_public_path__ + "static/media/icon-right-filled-black.c9f6bfe9.svg";